import { InjectionToken } from '@angular/core';
import { Y42RouteDetailTab } from '../routing/y42-router.model';

export interface DetailTabModel {
  path: Y42RouteDetailTab;
  logo: string;
  label: string;
  description: string;
}

export const DETAIL_TABS = new InjectionToken<DetailTabModel[]>('Detail Tabs');
